import { render, staticRenderFns } from "./hotCollege.vue?vue&type=template&id=c52b409e&scoped=true&"
import script from "./hotCollege.vue?vue&type=script&lang=js&"
export * from "./hotCollege.vue?vue&type=script&lang=js&"
import style0 from "./hotCollege.vue?vue&type=style&index=0&id=c52b409e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c52b409e",
  null
  
)

export default component.exports